import styled from '@emotion/styled';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Autocomplete, CircularProgress, Grid, MenuItem, Popper, Select, Tab, Tabs, TextField } from '@mui/material';
import { Box } from '@mui/system';
import React, { useState, useEffect } from 'react';
import MainCard from 'ui-component/cards/MainCard';
import Insurance from 'ui-component/insurance/Insurance';
import Investments from 'ui-component/investments/Investments';
import Loans from 'ui-component/loans/Loans';
import Policy from 'ui-component/Policy/Policy';
import Recurring from 'ui-component/recurring/Recurring';
import { get } from '../../axios/apiService';
import { Modules } from 'store/constant';
import { generateLabel } from 'utils/commonfunction';

const options = [
  { label: 'The Godfather', id: 1 },
  { label: 'Pulp Fiction', id: 2 }
];

const CustomPopper = styled(Popper)({
  '& .MuiAutocomplete-paper': {
    backgroundColor: '#f5f5f5',
    color: '#000'
  }
});

function WillManagement() {
  const [value, setValue] = useState('insurance');
  const [options, setOptions] = useState(); // Array to hold the options //[{ id: '', label: '' }]
  const [loading, setLoading] = useState(false); // Loading state for lazy loading
  const [open, setOpen] = useState(false); // To track if the dropdown is open
  const [hasMore, setHasMore] = useState(true); // To track if more data is available to load
  const [selectedOption, setSelectedOption] = useState({ id: '', label: '' });
  const [page, setPage] = useState(0);
  const [insuranceTabAvailable, setInsuranceTabAvailable] = useState(false);
  const [loansTabAvailable, setLoansTabAvailable] = useState(false);
  const [investmentTabAvailable, setInvestmentTabAvailable] = useState(false);
  const [recurringTabAvailable, setRecurringTabAvailable] = useState(false);
  const [policyTabAvailable, setPolicyTabAvailable] = useState(false);
  const [customerId, setCustomerId] = useState(null);

  const fetchCustomer = async () => {
    setLoading(true);
    try {
      let response = await get(`Customer?page=${page}&pageSize=999999`);
      const customerData = response?.values?.map((x) => {
        // return { id: x.id, label: x?.givenName + " " + x?.displayName };
        return {
          id: x.id,
          label: generateLabel({
            givenName: x?.givenName || "",
            displayName: x?.displayName || "",
            mobileNumber: x?.mobileNumber || "",
          }),
        };
      });
      console.log({ customerData });

      if (options?.length > 0) {
        setOptions((prevOptions) => [...prevOptions, ...customerData]);
      } else {
        setOptions(customerData);
      }
      setLoading(false);

      // if (customerData.length < 10) setHasMore(false);
      const totalCount = response.totalCount;
      const hasMoreData = page * 100 + customerData.length < totalCount;

      if (hasMoreData) {
        setPage(page + 1); // Increment the page number
      } else {
        setHasMore(false); // No more data to fetch
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (open && (!options || options?.length === 0)) {
      fetchCustomer();
    }
  }, [open]);

  useEffect(() => {
    const UserPermissions = JSON.parse(localStorage.getItem(`UserPermissions`));
    if (UserPermissions?.find((x) => x.moduleId === Modules.WillManagement_Insurance)) {
      setInsuranceTabAvailable(UserPermissions?.find((x) => x.moduleId === Modules.WillManagement_Insurance).readRights);
    }

    if (UserPermissions?.find((x) => x.moduleId === Modules.WillManagement_Loans)) {
      setLoansTabAvailable(UserPermissions?.find((x) => x.moduleId === Modules.WillManagement_Loans).readRights);
    }

    if (UserPermissions?.find((x) => x.moduleId === Modules.WillManagement_Investments)) {
      setInvestmentTabAvailable(UserPermissions?.find((x) => x.moduleId === Modules.WillManagement_Investments).readRights);
    }

    if (UserPermissions?.find((x) => x.moduleId === Modules.WillManagement_Recurring)) {
      setRecurringTabAvailable(UserPermissions?.find((x) => x.moduleId === Modules.WillManagement_Recurring).readRights);
    }

    if (UserPermissions?.find((x) => x.moduleId === Modules.WillManagement_Policy)) {
      setPolicyTabAvailable(UserPermissions?.find((x) => x.moduleId === Modules.WillManagement_Policy).readRights);
    }
  }, []);

  const handleScroll = (event) => {
    const bottom = event.target.scrollHeight - event.target.scrollTop === event.target.clientHeight;
    if (bottom && hasMore && !loading) {
      fetchCustomer();
    }
  };

  const handleChangeCustomer = (event) => {
    const selectedId = event.target.value;
    const selectedLabel = options.find((option) => option.id === selectedId)?.label;
    setSelectedOption({ id: selectedId, label: selectedLabel });
  };

  const handleCustomerChange = (event, newValue) => {
    if (newValue) {
      setSelectedOption(newValue);
      setCustomerId(newValue.id);
    } else {
      setSelectedOption({ id: '', label: '' });
      setCustomerId(null);
    }
  };


  return (
    <>
      <MainCard title="Will Management">
        <Grid container spacing={2} sx={{ padding: '10px' }}>
          <Grid item xs={12} md={12} lg={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Autocomplete
              open={open}
              onOpen={() => setOpen(true)}
              onClose={() => setOpen(false)}
              loading={loading}
              options={options || []}
              getOptionLabel={(option) => option.label}
              onChange={handleCustomerChange}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select a customer"
                  variant="outlined"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {loading ? <CircularProgress color="inherit" size={20} /> : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
              style={{ width: 200 }}
            />
          </Grid>
        </Grid>

        {/* Tab Section */}
        <Grid container spacing={2} sx={{ marginTop: '20px' }}></Grid>
        <Grid item xs={12} md={12} lg={12}>
          <TabContext value={value}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleChange} aria-label="lab API tabs example">
                {insuranceTabAvailable ? <Tab label="Insurance" value="insurance" /> : <></>}
                {loansTabAvailable ? <Tab label="Loans" value="loans" /> : <></>}
                {investmentTabAvailable ? <Tab label="Investments" value="investments" /> : <></>}
                {recurringTabAvailable ? <Tab label="Recurring" value="recurring" /> : <></>}
                {policyTabAvailable ? <Tab label="Policy" value="policy" /> : <></>}
              </TabList>
            </Box>
            {/* Insurance Tab content */}
            <TabPanel value="insurance">
              <Insurance customerId={selectedOption.id} />
            </TabPanel>
            {/* Loans Tab content */}
            <TabPanel value="loans">
              <Loans customerId={selectedOption.id} />
            </TabPanel>
            {/* Investments Tab content */}
            <TabPanel value="investments">
              <Investments customerId={selectedOption.id} />
            </TabPanel>
            {/* Recurring Tab content */}
            <TabPanel value="recurring">
              <Recurring customerId={selectedOption.id} />
            </TabPanel>
            <TabPanel value="policy">
              <Policy customerId={selectedOption.id} />
            </TabPanel>
          </TabContext>
        </Grid>
      </MainCard>
    </>
  );
}

export default WillManagement;
